(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/Behavior', 'app/widget/modal/modalService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var TorsoBehavior = require('backbone-torso/modules/Behavior');
    var modalService = require('./modalService');
    module.exports = factory(TorsoBehavior, modalService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function(TorsoBehavior, modalService) {
  'use strict';

  /**
   * 'Use Modal' Behavior
   *
   * This behavior is for views --- generally perspectives --- that need to instantiate modals
   * (such as confirmation dialogs and alert dialogs).  See also ModalBehavior.js, a behavior for modal views.
   * themselves.
   *
   * If you've added this behavior to a view, within the view you can instantiate a modal with
   * this.showModal(<modal view>, <resolveCallback>, <rejectCallback>) --- the callbacks are optional, but
   * each takes a single <results> parameter.  <resolveCallback> is called immediately if the modal is closed
   * by resolve(<results>), and <rejectCallback> is called immediately if the modal is closed by
   * reject(<results>).
   *
   * For example:
   *
   *  var thisView = this;
   *  this.showModal(new BlahModalView({
   *    someOption: 'blah.blah',
   *    otherOption: false
   *  }), function(results) {
   *    if (results.blah === 'blah') {
   *      thisView.doTheThing(results.foo);
   *    } else {
   *      thisView.doTheOtherThing(results.bar);
   *    }
   *  });
   *
   * or:
   *
   *  this.showModal(new ModalDialogWidget({
   *    headerKey: 'blah.blahHeader',
   *    descriptionKey: 'blah.blahDescription'
   *  }), _.bind(this.doTheThing, this));
   *
   *
   * @class UseModalBehavior
   */
  return TorsoBehavior.extend({

    mixin: {

      /**
       * Shows the modal (using the modalService).
       *
       * @method showModal
       * @param modalView {View} the view instance to display as a modal.
       * @param [resolveCallback=undefined] {function(results)} if present, will be called when the modal is resolved.
       * @param [rejectCallback=undefined] {function(results)} if present, will be called when the modal is rejected.
       */
      showModal: function(modalView, resolveCallback, rejectCallback) {
        modalService.showModal(this.view, modalView, resolveCallback, rejectCallback);
      },

      /**
       * Check to see if the modal instance for the given modalView is already in the stack.
       * Returns true even if the modal is 'hidden'.
       *
       * @method isModalInStack
       * @param modalView {View} the view instance to check
       * @returns {boolean} whether the modal is already in the stack
       */
      isModalInStack: function (modalView) {
        return modalService.isModalInStack(modalView);
      },

      /**
       * Check to see if the modal instance for the given modalView is the top-most active modal
       * in the stack (i.e. should be receiving input).
       *
       * @method isTopActiveModal
       * @param modalView {View} the view instance to check
       * @returns {boolean} whether the modal is the top-most active one
       */
      isTopActiveModal: function (modalView) {
        return modalService.isTopActiveModal(modalView);
      }
    },

    /**
     * @method postrender
     * @override
     */
    postrender: function() {
      modalService._reattachModalChildren(this.view);
    }

  });
}));
